export default __webpack_public_path__ + "static/moneybus_small-2-ccdac41a6f8b66479ae0aa123171529a.webp";